"use client";

import GeneralListingCard, {
  ListingCardLoading,
} from "@/components/listing-card/listing-card";
import styles from "./page.module.css";
import { useLocale, useTranslations } from "next-intl";
import { useEffect, useMemo, useRef } from "react";
import { useUserAuthDataContext } from "@/global-context/user-auth-context";
import { GetSavedListingsResponse } from "./types";
import { useSavedListingsStore } from "./useSavedListingsStore";
import { useListingsCacheStore } from "@/global-cache/useListingsCacheStore";
import { ListingCardData, PurposeEnum, TypeEnum } from "@/types/types";
import { Pagination } from "@/components/pagination/pagination";
import PageSearchbar from "./searchbars/page-searchbar";
import MobileSearchbar from "./searchbars/mobile-searchbar";

export default function SavedListingsLayout({
  savedListingsData,
}: {
  savedListingsData: GetSavedListingsResponse;
}) {
  const t = useTranslations("SavedListings");
  const locale = useLocale();
  const { userData } = useUserAuthDataContext();
  const { state, initFirstPage, fetchPage, type, purpose, listingsLocale } =
    useSavedListingsStore();
  const scrollContainerRef = useRef<HTMLElement>(null);
  const cachedListings = useListingsCacheStore((state) => state.listings);
  const setCache = useListingsCacheStore((state) => state.setMultipleListings);
  const savedListings: ListingCardData[] = useMemo(() => {
    return state.listingsIds.map((id) => cachedListings[id]).filter(Boolean);
  }, [state.listingsIds, cachedListings]);

  useEffect(() => {
    if (
      (!state.isLoaded && savedListingsData?.fetched_at !== state.fetched_at) ||
      savedListingsData.total_count !== state.total_count ||
      locale !== listingsLocale
    ) {
      initFirstPage(savedListingsData, locale, setCache);
    }
    // if (savedListingsData.total_count !== total_count) {
    //   initFirstPage(savedListingsData, locale, setCache);
    // }
  }, [locale, savedListingsData]);

  // const { isXs, isSm, isMd, isLg } = useBreakpoints();

  return (
    <main className={styles.main} ref={scrollContainerRef}>
      <h2 className={styles.title}>{t("title")}</h2>
      <PageSearchbar locale={locale} sessionId={userData.idToken} />
      <MobileSearchbar sessionId={userData.idToken} />
      {/* <PagesSearchbar /> */}

      {!state.pageLoading &&
      savedListings.length === 0 &&
      (type !== TypeEnum.DEFAULT ||
        purpose !== PurposeEnum.DEFAULT ||
        state.current_suggestion.value !== "" ||
        state.current_suggestion.type !== "") ? (
        <h2 className={styles.noListings}>{t("noListingsMatch")}</h2>
      ) : !state.pageLoading &&
        savedListings.length === 0 &&
        type === TypeEnum.DEFAULT &&
        purpose === PurposeEnum.DEFAULT &&
        state.current_suggestion.value === "" &&
        state.current_suggestion.type === "" ? (
        <h2 className={styles.noListings}>{t("noListings")}</h2>
      ) : null}

      <div className={styles.listingsWrapper}>
        <ul className={styles.listingsGrid}>
          {state.pageLoading &&
            [...Array(12)].map((_, i) => {
              return (
                <li className={styles.listingWrapperLoading} key={i}>
                  <ListingCardLoading
                    hasModifyButton={false}
                    hasRoundButtons={true}
                    isResizable={false}
                    hasActions={false}
                    hasStatusLabel={false}
                  />
                </li>
              );
            })}
          {savedListings.map((listing, _) => {
            return (
              <li className={styles.listingWrapper} key={listing.listing_id}>
                <GeneralListingCard
                  data={listing}
                  isResizable={false}
                  hasActions={false}
                  hasStatusLabel={false}
                  hasRoundButtons={true}
                />
              </li>
            );
          })}
        </ul>
      </div>
      {state.total_count > 0 && (
        <div className={styles.paginationWrapper}>
          <Pagination
            total={state.total_count}
            pageSize={24}
            currentPage={state.page_number}
            onPageChange={async (number) => {
              if (number === state.page_number) return;
              await fetchPage(locale, userData.idToken, number, setCache);
            }}
          />
        </div>
      )}
    </main>
  );
  // return (
  //   <main className={styles.main}>
  //     <div className={styles.pageWrapper}>
  //       <MobileSearchbar />
  //       <Searchbar />
  //       {pageLoading &&
  //         [...Array(12)].map((_, i) => {
  //           return (
  //             <div className={styles.loadingCardWrapper} key={i}>
  //               <ListingCardLayoutLoading>
  //                 <ListingCardLoading
  //                   hasModifyButton={false}
  //                   hasRoundButtons={false}
  //                   isResizable={true}
  //                   hasActions={true}
  //                   hasStatusLabel={true}
  //                 />
  //               </ListingCardLayoutLoading>
  //             </div>
  //           );
  //         })}
  //       <ul className={styles.listingsList}>
  //         {listings.map((listing, index) => {
  //           return (
  //             <li className={styles.listingItem} key={index}>
  //               <motion.div
  //                 initial={{ opacity: 0 }}
  //                 animate={{ opacity: 1 }}
  //                 transition={{
  //                   duration: 0.3,
  //                   delay: 0.0,
  //                   ease: "easeIn",
  //                 }}
  //               >
  //                 {isRefetchingListingCardLoading === listing.listing_id ? (
  //                   <ListingCardLoading
  //                     hasModifyButton={false}
  //                     hasRoundButtons={true}
  //                     isResizable={false}
  //                     hasActions={false}
  //                     hasStatusLabel={false}
  //                   />
  //                 ) : (
  //                   <ListingCard
  //                     data={listing}
  //                     isResizable={false}
  //                     hasActions={false}
  //                     hasStatusLabel={false}
  //                     hasRoundButtons={true}
  //                   />
  //                 )}
  //               </motion.div>
  //             </li>
  //           );
  //         })}
  //       </ul>
  //       {has_more_pages_front_end && (
  //         <button
  //           disabled={loadingNextPageData}
  //           onClick={async (e) => {
  //             await fetchNextPage(locale, userData.sessionId);
  //           }}
  //           className={styles.loadButton}
  //         >
  //           Load More
  //         </button>
  //       )}
  //     </div>
  //   </main>
  // );
}
